// „Ukazováček" — highlight ONE element on the page with a pulsing ring and a
// one-line hint, on demand (never a step-by-step tour). Anchors are
// `data-spot="<target>"` attributes; when the target is not on screen (mobile
// drawer closed, other page) the hint alone is shown — `hint` is therefore
// always written as plain directions („Menu vlevo → Doména").
export interface SpotlightRequest {
  target: string
  hint: string
  // Bumped per request so the same target can be asked for twice.
  seq: number
}

export function useSpotlight() {
  const req = useState<SpotlightRequest | null>('ui-spotlight', () => null)
  let seq = 0
  function spotlight(target: string, hint = '') {
    req.value = { target, hint, seq: ++seq }
  }
  function clear() {
    req.value = null
  }
  return { req, spotlight, clear }
}
